export default "__VITE_ASSET__DQlRXYOz__"